import { IsNotEmpty } from 'class-validator';

export class IMyDate {
  @IsNotEmpty()
  year: number;
  @IsNotEmpty()
  month: number;
  @IsNotEmpty()
  day: number;
}
